// ContactUs.js

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ContactUsForm from "./ContactUsForm";

//#101522 --> Dark colour background
const ContactContainer = styled.div`
  margin: 0 auto;
  padding: 20px;
  background-color: ${(props) =>
    props.orgidmain === 2105 ? "#f9fbfd" : "#101522"};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  font-family: "Source Sans Pro", sans-serif;
`;

const Card = styled.div`
  background-color: #1c2331;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);

  h2 {
    color: #fff;
    font-family: cursive;
    margin-bottom: 15px;
  }

  p {
    color: #ccc;
    margin-bottom: 0;
  }
`;

const ContactUs = () => {
  const [data, setdata] = useState([]);
  const [orgidmain, setorgidmain] = useState(null);

  const GetImageData = async (orgId) => {
    const sendData2 = {
      OrgId: Number(orgId),
    };

    //console.log(sendData2);

    try {
      const response = await fetch(
        `https://zaingielatestapi.azurewebsites.net/api/Main/GetOrganizationInfo`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sendData2),
        }
      );

      const data = await response.json();

      //console.log(data);
      // Convert strings to booleans (supports array or object)

      setdata(data);
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const sendData2 = {
          ActualWebsite: window.location.hostname,
          //ActualWebsite: "healcop.com",
          //ActualWebsite: "eh.mounts.in",
        OrgName: "test",
      };

      try {
        await fetch(
          `https://zaingielatestapi.azurewebsites.net/api/FLOW/Getorgiddynamic`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sendData2),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            const orgid = data.orgId;
            setorgidmain(orgid);
            GetImageData(orgid);
          });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  return (
    <ContactContainer orgidmain={orgidmain}>
      <center>
        <h1
          style={{
            color: `${orgidmain === 2105 ? "#101522" : "#fff"}`,
            fontFamily: "cursive",
            marginBottom: 50,
          }}
        >
          Contact Us
        </h1>
      </center>

      <ContactUsForm orgid={orgidmain} />
      {/*           <Card>*/}
      {/*               <h2>Address</h2>*/}
      {/*               <p>*/}

      {/*                   {[*/}
      {/*                       data?.orgName,*/}
      {/*                       data?.orgAddress,*/}
      {/*                       data?.orgCity,*/}
      {/*                       data?.orgState,*/}
      {/*                       data?.orgCountry,*/}
      {/*                       data?.orgPin*/}
      {/*                   ]*/}
      {/*                       .filter((item) => item !== null && item !== undefined && item !== "")*/}
      {/*                       .join(", ")}*/}
      {/*<br />*/}
      {/*                   */}
      {/*<b style={{ color: '#fff' }}>GSTN NO </b>-  {data.vatNumber}<br />*/}

      {/*               </p>*/}
      {/*           </Card>*/}
      {/*           <Card>*/}
      {/*               <h2>GSTN NO</h2>*/}
      {/*               <p>{data.vatNumber}</p>*/}
      {/*           </Card>*/}
      {/*           <Card>*/}
      {/*               <h2>Phone Number</h2>*/}
      {/*               <p>+{data.orgLandline1}</p>*/}
      {/*           </Card>*/}
    </ContactContainer>
  );
};

export default ContactUs;
